import React from 'react'
import { twMerge } from 'tailwind-merge'

export const modalStyles = {
  container:
    'fixed flex flex-col justify-center align-middle p-10 z-[9990] top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 bg-white text-black w-4/5 md:w-auto max-h-[100svh]',
  extendedContainer:
    'fixed flex flex-col justify-center align-middle p-10 z-[9990] top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 bg-white text-black w-10/12 max-h-[100svh]',
  overlay:
    'fixed overscroll-contain z-[9980] top-0 right-0 bottom-0 left-0 w-full h-full bg-black opacity-20',
  button: 'absolute top-4 right-4 w-[1.3rem]'
}

export const Overlay = ({ onClick = () => {}, className = '' }) => {
  return (
    <div
      onClick={() => onClick()}
      className={twMerge(modalStyles.overlay, className)}
    />
  )
}

export const DefaultCloseIcon = () => {
  return (
    <svg viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M6.513 7.947l-4.94 4.94L2.987 14.3l4.94-4.94 5.013 5.013 1.414-1.414L9.34 7.947l4.96-4.96-1.414-1.414-4.96 4.96L3.04 1.646 1.626 3.06l4.887 4.887z'
        fill='currentColor'
        fillRule='evenodd'
      />
    </svg>
  )
}

export const renderContent = (
  content: string | React.ReactElement | JSX.IntrinsicElements | undefined
) => {
  if (!content) {
    return null
  }
  return typeof content === 'string' ? (
    <div dangerouslySetInnerHTML={{ __html: content }} />
  ) : (
    <>{content}</>
  )
}
